<template>
    <div>
        <nav-bar />
        <aside-menu
            :menu="menu"
            @open-modal="isContactModalOpen = true"
        />
        <div
            class="main"
        >
            <router-view />
        </div>
        <contact-modal
            v-if="isContactModalOpen"
            class="px-8"
            @close="isContactModalOpen = false"
            @submit="isContactModalOpen = false"
        />
    </div>
</template>

<script setup>
import base from '@/api/base'
import AsideMenu from '@/spComponents/Utilities/AsideMenu'
import ContactModal from '@/components/Utilities/ContactModal'
import NavBar from '@/spComponents/Utilities/NavBar'
import menu from '@/spMenu.js'
import { onMounted, ref } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
// 初期アバター設定
store.commit('user', { avatar: 'img/no_user_avatar.png' })

const isContactModalOpen = ref(false)

onMounted(async() => {
    const response = await base.get('session', {}, true)
    if (response) {
        store.commit('setBasicInfo', response)
    }
})
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap');
body {
    font-family: 'Noto Sans JP', sans-serif !important;
    padding-top: 0 !important;
}
html {
    font-size: 12px;
}
.contact-field {
    height: 200px;
}

html, body {
    min-height: 100vh;
}

.main {
    min-height: calc(100vh - 120px);
    overflow: auto !important;
}
</style>
